module.exports = __webpack_public_path__ + "img/br.a102e563.svg";